export class Api {

  private getBaseUrl() {
    return import.meta.env.VITE_API_BASE_URL;
  }

  private getApiVersion(code: string) {
    const legacyProjectCodePattern = /^\d{7}[A-Za-z]{2}$/;
    const isLegacyProjectCode = legacyProjectCodePattern.test(code);

    return isLegacyProjectCode ? "v1" : "v2";
  }

  getUsers(): Promise<Array<string>> {
    return fetch(`${this.getBaseUrl()}/user`)
      .then(result => result.json());
  }

  getAssignmentDetail(request: GetAssignmentDetailRequest): Promise<Array<{username: string}>> {
    return fetch(`${this.getBaseUrl()}/v2/assignment-detail/${request.inspectionId}`)
      .then(result => result.json());
  }

  createInspection(request: CreateInspectionRequest) {
    const endpoint = `${this.getBaseUrl()}/${this.getApiVersion(request.inspectionId)}/inspection`;

    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(request)
    })
  }
}

type GetAssignmentDetailRequest = {
  inspectionId: string
}

type CreateInspectionRequest = {
  inspectionId: string,
  users: Array<string>
}